module.exports = __webpack_public_path__ + "img/main.591a2a44.png";